import { Lock } from 'lucide-react';
import type { ChangeEvent } from 'react';

import InputErrorMessage from '../components/common/InputErrorMessage';
import type { ErrorMessage } from '../helpers/type';

interface PasswordInputFieldProps {
  id: string;
  name: string;
  label: string;
  value: string;
  error: ErrorMessage;
  border: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const PasswordInputField = ({
  id,
  name,
  label,
  value,
  error,
  border,
  onChange,
}: PasswordInputFieldProps) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <div className="mt-1 relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Lock className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id={id}
        name={name}
        type="password"
        required
        value={value}
        onChange={onChange}
        className={`appearance-none block w-full pl-10 pr-3 py-2 border ${border} rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary`}
        placeholder="••••••••"
      />
    </div>
    <InputErrorMessage message={error} />
  </div>
);

export default PasswordInputField;
